import axios from 'axios';

export default async function newThread() {
  try {
    const response = await axios.post(
      'https://api.openai.com/v1/threads/runs',
      {
        "assistant_id": "asst_q7m23GWbA4C5qSyInsdEGBFI",
        "thread": {
            "messages": [
                {
                    "role": "user",
                    "content": "bom dia"
                }
            ]
        }
    },
      {
        headers: {
          "Authorization": `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          "OpenAI-Beta": 'assistants=v2',
          "Content-Type": 'application/json'
        },
      }
    );

    const threadId = response.data.thread_id;
    console.log('Thread ID:', threadId);
    return threadId;
  } catch (error) {
    console.error('Erro:', error);
    throw error;
  }
}
